/**
 * 地图厂商坐标类型枚举
 */
export enum MapSupplierType {
  /**
   * AMap
   */
  MapSupplierTypeAMap = -1,
  /**
   * Baidu
   */
  MapSupplierTypeBaidu = 0,
  /**
   * MapBar
   */
  MapSupplierTypeMapBar = 1,
  /**
   * MapABC
   */
  MapSupplierTypeMapABC = 2,
  /**
   * SoSoMap
   */
  MapSupplierTypeSoSoMap = 3,
  /**
   * AliYun
   */
  MapSupplierTypeAliYun = 4,
  /**
   * Google
   */
  MapSupplierTypeGoogle = 5,
  /**
   * GPS
   */
  MapSupplierTypeGPS = 6,
}
